import React from 'react';

const Vue_Component_Instance_root = () => {
  return (
    <div>
      <h1>Vue_Component_Instance_root Component</h1>
      <p>This is the Vue_Component_Instance_root tutorial page.</p>
    </div>
  );
}

export default Vue_Component_Instance_root;
